import constants from '../../constants';
export default {
  header: '#f1efe4',
  statusBar: '#f1efe4',
  background: constants.Colors.newBackground,
  inputBackground: constants.Colors.newBackground,
  link: '#008afd',
  success: constants.Colors.Green,
  error: '#ff6f60',
  container: '#fff',
  layer1: '#e4eaf2',
  layer2: '#e4eaf2',
  layer3: '#e4eaf2',
  activeTab: '#005089',
  inActiveTab: constants.Colors.WildBlueYonder,
  pinkColor: constants.Colors.WildStrawberry,
  placeholderBackground: constants.Colors.MidnightNavy,
  placeholderFactText: '#131740',
  placeholderColor: '#182152',
  accountHeader: '#131740',
  profileHeader: '#182152',
  svgDefault: '#182152',
  svgPrimary: '#fff',
  svgSecondary: '#1b1f3f',
  dashboardSvgPrimary: '#1b1f3f',
  dashboardSvgSecondary: '#fff',

  simpleTextInputBG: '#fff',
  simpleTextInput: '#1b1f3f',
  simpleTextInputLabel: '#1b1f3f',
  simpleTextInputError: '#ff6f60',
  simpleTextInputPlaceholder: '#555a78',
  simpleTextInputSelection: '#1b1f3f',

  //for all modal
  modalContainer: '#e6e3d4',

  //for tooltip
  toolTipBackground: '#012f57',
  toolTipOverlayColor: 'transparent',
  tooltipInfoText: '#fff',

  profileIndicatorCheckedPrimary: '#004f89',
  profileIndicatorCheckedSecondary: '#012f57',

  //for placeholder loader
  placeholderLoaderMessage: '#1b1f3f',

  //for loader
  loader: '#1b1f3f'
};
